<template>
  <div id="park">
    <header-nav></header-nav>
    <banner-component :banner-data="pageData"></banner-component>
    <div class="content">
      <!-- 左 -->
      <article-side-bar :article-list-nav="pageData"></article-side-bar>    
      <!--右-->
      <div class="content_right">
        <div class="content_header">
          <span class="title">院校机构</span>
          <span class="card">高校科研院所专利及科技成果 > 院校机构</span>
        </div>
        <ul class="pic_list">
        	<li class="pic" v-for="item in patentList" :key="item.collegesCode" @click="goList(item)">
            <div class="img" :style="{'background': 'url('+item.img1+')',backgroundRepeat:'no-repeat', backgroundPosition:'center center', backgroundSize: 'cover'}" alt=""></div>
            <p>{{item.collegesName}}</p>
        	</li>
        </ul>
      </div>
    </div>
    <partner-list></partner-list>
    <common-footer></common-footer>
  </div>
</template>

<script>
  import HeaderNav from '@/components/HeaderNav.vue'
  import CommonFooter from '@/components/CommonFooter.vue'
  import PartnerList from '@/components/PartnerList.vue'
  import BannerComponent from '@/components/BannerComponent.vue'
  import ArticleSideBar from '@/components/ArticleSideBar.vue'
  import colleges from './colleges'
  export default {
    components: {
      HeaderNav,
      CommonFooter,
      PartnerList,
      BannerComponent,
      ArticleSideBar
    },
    data() {
      return {
      	patentList:colleges
      }
    },
    computed: {
      pageData: function () {
        let data = this.$store.state.app.static.find((item) => {
          return item.menuId == this.$route.query.menuId
        })
        return data
      }

    },
    methods: {
      goList(item){
        this.$router.push(`/patentSearch/introduction?menuId=30&plateId=31&colleges_code=${item.collegesCode}`)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
 // $themeColor: #3e76fc;
  #park {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    background-color: #fff;
    .content {
      width: 1200px;
      display: flex;
      margin-bottom: 150px;
      .content_right {
        width: 1112px;
        padding-left: 34px;
        .content_header {
          width: 100%;
          height: 86px;
          border-bottom: 1px solid $themeColor;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .title {
            font-size: 28px;
            color: $themeColor;
          }
          .card {
            font-size: 14px;
            color: #333;
          }
        }
      }
      .pic_list{
      	@include flex(center, flex-start);
      	flex-wrap:wrap;
      	.pic{
      		width: 45%;
      		margin: 20px 10px;
      		transition:ease transform .3s;
          cursor: pointer;
      		&:hover{
						transform:scale(1.05);
      		}
          .img{
            //max-height: 250px;
            width: 100%;
            height: 280px;
            //height: auto;
          }
          p{
            text-align: center;
            color: #333;
          }
      	}
      }
    }
  }
</style>
